/* eslint-disable no-undef */
import React from 'react';
import { SimpleImg } from 'react-simple-img';
import PropTypes from 'prop-types';
import './style.sass';
import { StarRateIcon } from '../SharedComponents/Icons';

const ListItem = props => (
  <div className="locations-list-item">
    <a
      href={props.href}
      className="locations-list-item__image"
    >
      <SimpleImg
        src={props.image}
        alt={props.title}
      />
    </a>
    <div className="locations-list-item__info">
      <div className="locations-list-item__rating">
        {[...Array(props.starsRating)].map(elem => (
          <StarRateIcon key={elem} />
        ))}
      </div>
      <h4 className="bold black">
        <a href={props.href}>{props.title}</a>
      </h4>
      <p>{props.body}</p>
      <a href={props.href} className="underlined">{I18n.t('location.see_office_details')}</a>
    </div>
  </div>
);

ListItem.propTypes = {
  href: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  starsRating: PropTypes.number,
};

ListItem.defaultProps = {
  href: '',
  image: '',
  title: '',
  body: '',
  starsRating: 4,
};

export default ListItem;
